export const COLORS = {
  primary: {
    orange: '#EE8544',
    lightOrange: '#FFF5EC',
    darkOrange: '#FFB547',
    teal: '#519EA6',
  },
  text: {
    primary: '#333333',
    gray: '#757575',
    light: '#FFFFFF',
  },
  background: {
    white: '#FFFFFF',
    lightGray: '#F5F5F5',
  },
  border: {
    light: '#E0E0E0',
  },
} as const;

// Tailwind CSS에서 사용할 수 있도록 색상 클래스도 export
export const COLOR_CLASSES = {
  primary: {
    orange: 'text-[#EE8544]',
    lightOrange: 'bg-[#FFF5EC]',
    darkOrange: 'text-[#FFB547]',
  },
  text: {
    primary: 'text-[#333333]',
    gray: 'text-[#757575]',
    light: 'text-[#FFFFFF]',
    orange: 'text-[#EE8544]',
  },
  background: {
    white: 'bg-[#FFFFFF]',
    lightGray: 'bg-[#F5F5F5]',
    teal: 'bg-[#519EA6]',
  },
  border: {
    light: 'border-[#E0E0E0]',
  },
} as const;
